import { Component, Input, OnInit } from "@angular/core";
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { CMovementOrder } from './../../model/action-tablet.model';

@Component({
  selector: 'app-action-tablet-movement-order-list',
  templateUrl: './action-tablet-movement-order-list.component.html',
  styleUrls: ['./action-tablet-movement-order-list.component.scss']
})
export class ActionTabletMovementOrderList implements OnInit {


  columnsToDisplay: string[] = ['priority', 'referenceDate', 'scope', 'identifier', 'currentStation', 'targetStation', 'transportReference', 'processingStatus'];
  dataSource: MatTableDataSource<CMovementOrder> = new MatTableDataSource(new Array<CMovementOrder>);

  @Input("movementOrders") set movementOrders(movementOrders: Array<CMovementOrder>) {
    this.dataSource = new MatTableDataSource(movementOrders);
  }


  constructor() {

  }
  ngOnInit(): void {

  }
}
